module.exports = __webpack_public_path__ + "static/img/0001吉林市人民政府.87ab673.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0001吉林市人民政府.jpg
// module id = Ks8k
// module chunks = 0